<template>
  <table>
    <thead>
      <tr>
        <th>辅导科目</th>
        <th v-for="item in basicClassList" :key="item.BzNum">{{item.BzCName}}</th>
      </tr>
      <tr v-for="(item, index) in tutoringClass" :key="index">
        <td>{{item.KsName}}</td>
        <td v-for="(ii, idx) in basicClassList" :key="`${index}-${idx}`">
          <template v-if="idx === 0">
            <template v-if="jingjiangObj.BzContainKsList && jingjiangObj.BzContainKsList.length > 0">
              <p v-if="jingjiangObj.BzContainKsList[index].KsMultiVersionList && jingjiangObj.BzContainKsList[index].KsMultiVersionList.length > 0"
                  @click="$emit('changeSVideo', jingjiangObj.BzContainKsList[index].KsMultiVersionList[0].PlayUrl, jingjiangObj.BzContainKsList[index].KsName)">
                <img src="https://img2.233.com/wx/union/pure/pc/blue/st_ic.png" v-if="skinColor === 'blue'">
                <img src="https://img2.233.com/wx/union/pure/pc/green/st_ic.png" v-else-if="skinColor === 'green'">
                <img src="https://img2.233.com/wx/union/pure/pc/red/st_ic.png" v-else>
                <i></i>
                <span>{{jingjiangObj.BzContainKsList[index].KsMultiVersionList[0].TeacherName || "网校老师"}}</span>
              </p>
              <p v-if="jingjiangObj.BzContainKsList[index].KsMultiVersionList && jingjiangObj.BzContainKsList[index].KsMultiVersionList.length > 1"
                  @click="$emit('changeSVideo', jingjiangObj.BzContainKsList[index].KsMultiVersionList[1].PlayUrl, jingjiangObj.BzContainKsList[index].KsName)">
                <img src="https://img2.233.com/wx/union/pure/pc/blue/st_ic.png" v-if="skinColor === 'blue'">
                <img src="https://img2.233.com/wx/union/pure/pc/green/st_ic.png" v-else-if="skinColor === 'green'">
                <img src="https://img2.233.com/wx/union/pure/pc/red/st_ic.png" v-else>
                <i></i>
                <span>{{jingjiangObj.BzContainKsList[index].KsMultiVersionList[1].TeacherName || "网校老师"}}</span>
              </p>
            </template>
          </template>
          <template v-else>
            <template v-if="ii.BzContainKsList && ii.BzContainKsList.length > 0">
              <template v-if="ii.BzContainKsList[index].KsMultiVersionList && ii.BzContainKsList[index].KsMultiVersionList.length > 0">
                {{ii.BzContainKsList[index].KsMultiVersionList[0].TeacherName}}
              </template>
              <template v-else>--</template>
            </template>
          </template>
        </td>
      </tr>
    </thead>
  </table>
</template>

<script>
export default {
  name: "Aclass",
  props: {
    basicClassList: {
      props: {
        type: Array,
        default: () => []
      }
    },
    skinColor: {
      type: String,
      default: ""
    }
  },
  computed: {
    tutoringClass() {
      return this.basicClassList[0].BzContainKsList
    },
    jingjiangObj() {
      return this.basicClassList.find(item => item.IsFlag === 1) || {}
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/css/index.scss";
table{
  width: 1200px;
  margin: 0 auto 36px;
  background: white;
  box-shadow: 1px 15px 17px 1px rgba(0, 0, 0, 0.02);
  text-align: center;
  border-collapse: collapse;
  table-layout: auto;
  border-spacing: 0;
  tr{
    &:nth-last-child(1) {
      td{
        border-bottom: none;
      }
    }
    th{
      border-right: 1px solid #ECECEC;
      @include aclass_border_bottom();
      color: #343434;
      font-weight: bold;
      font-size: 15px;
      height: 81px;
      &:nth-child(1) {
        width: 150px;
      }
      &:nth-child(2) {
        width: 112px;
      }
    }
    td{
      border-right: 1px solid #ECECEC;
      border-bottom: 1px solid #DADADA;
      padding: 16px 10px;
      color: #565656;
      font-weight: 400;
      font-size: 15px;
      width: 120px;
      &:nth-child(1) {
        font-weight: bold;
        width: 150px;
      }
      &:nth-child(2) {
        background: #FAFAFA;
        padding: 0 10px;
        p{
          span{
            min-width: 50px;
            display: inline-block;
          }
        }
      }
      &:nth-last-child(1) {
        border-right: none;
      }
      p{
        line-height: 31px;
        &:nth-child(2){
          border-top: 1px dashed #DFDFDF;
          width: calc(100% + 20px);
          margin-left: -10px;
        }
        img{
          width: 19px;
          height: 15px;
          vertical-align: middle;
          vertical-align: middle;
          cursor: pointer;
        }
        i{
          width: 1px;
          height: 16px;
          background: #D3D3D3;
          margin: 0 10px;
          display: inline-block;
          vertical-align: middle;
        }
        span{
          font-weight: bold;
          vertical-align: middle;
        }
      }
    }
  }
}
</style>